import React from 'react';
import Footer from '../homepage/footer';
import Portfolio_image from './landingportfolio';

function Portfoliopage() {
    return (
        <div>
            <Portfolio_image/>
            <Footer/>
        </div>
    )
}

export default Portfoliopage;